import {UsedMainCategories} from "App/services/api";
import {FetchAction, FetchState} from "App/services";
import {ActionType} from "App/constants";

export {UsedMainCategories as State};

export function reducer(state: UsedMainCategories = [], action: FetchAction) {
    switch (action.state) {
        case FetchState.SUCCESS: {
            switch (action.type) {
                case ActionType.FETCH_MAINCATEGORIES: {
                    return action.payload
                }
                default:
                    return state;
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/maincategories.ts